// others
import { Nearby, lineEq, HoverLetterSpacing, Lerper, isMobile, isEditMode } from '@/scripts/utils';

// assets
import './DynamicHoverLink.scss';

const defaults = {
  el: null,
  line: '[data-role="line"]',
  distanceThreshold: { min: 0, max: 75 },
  scaleInterval: { from: 0, to: 1 },
  namespace: 'dynamic-hover-link',
};

export default class DynamicHoverLink {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    if (!options.el) {
      return;
    }

    this.namespace = options.namespace;

    this.el = options.el;
    this.$el = $(this.el);

    this.$text = $(`<span class="${this.namespace}__text">${this.$el.text()}</span>`);
    this.$line = $(`<span class="${this.namespace}__underline"></span>`);

    this.distanceThreshold = options.distanceThreshold;
    this.scaleInterval = options.scaleInterval;

    this.notDestroy = this.el.dataset.notDestroy;
    this.disableForPerformance = this.el.dataset.disableForPerformance;

    this.nearby = null;
    this.spacing = null;

    this.lerper = null;

    this.init();
  }

  destroy() {
    if (!this.notDestroy) {
      if (this.spacing) this.spacing.destroy();
      if (this.lerper) this.lerper.destroy();
    }
  }

  init() {
    if (!isEditMode()) {
      this.$el.addClass(this.namespace).html([this.$text, !isMobile() ? this.$line : '']);
    }
    if (!isMobile() && !isEditMode()) {
      this.spacing = new HoverLetterSpacing({
        element: this.$text[0],
        space: 1,
      });
      this.lerper = new Lerper({
        onTick: (value) => {
          this.$line.css({
            transform: `scaleX(${value})`,
          });
        },
      });
      Nearby.addElement(this.el, {
        notDestroy: this.notDestroy,
        disableForPerformance: this.disableForPerformance,
        onProgress: (distance) => {
          if (distance < this.distanceThreshold.max) {
            requestAnimationFrame(() => {
              const o = Math.max(lineEq(this.scaleInterval.from, this.scaleInterval.to, this.distanceThreshold.max, this.distanceThreshold.min, distance), this.scaleInterval.from);
              this.spacing.update(o);
              this.lerper.setValue(o);
            });
          } else {
            this.spacing.update(0);
            this.lerper.setValue(0);
          }
        },
      });
    }
  }
}



// WEBPACK FOOTER //
// ./components/DynamicHoverLink/DynamicHoverLink.js